import { v4 as _uuidv4 } from 'uuid';

export const uuidv4 = _uuidv4;
